module.exports = __webpack_public_path__ + "static/media/Bonhomme_coures.8e6febfe.png";